import { AdminEventJourneyDto } from '@ivy-monorepo/shared'
import { formatEventSource } from '../utils/eventJourney'
import EventStatTiles, { EventStatTile } from './EventStatTiles'

/** Funnel tiles plus RSVPs / "Get a Ticket" taps / tickets per source for one event. */
const EventJourneySummary = ({ summary }: { summary: AdminEventJourneyDto }) => {
  const { totals } = summary
  const tiles: EventStatTile[] = [
    ...(summary.partneredHotspotPublicIds.length > 0
      ? [
          { label: 'Hotspot modal auto-opened', value: totals.modalShown, users: totals.modalShownUsers },
          { label: 'Hotspot card taps', value: totals.cardTaps, users: totals.cardTapUsers },
          { label: 'Hotspot CTA taps', value: totals.ctaTaps, users: totals.ctaUsers, ofUsers: totals.modalShownUsers },
        ]
      : []),
    { label: '"Get a Ticket" taps', value: totals.getTicketsTaps, users: totals.getTicketsUsers },
    { label: 'RSVPs', value: totals.rsvps },
    { label: 'Tickets held', value: totals.tickets },
  ]

  return (
    <>
      <EventStatTiles tiles={tiles} />
      <table className="event-journey-sources">
        <thead>
          <tr>
            <th>Source</th>
            <th>RSVPs</th>
            <th>&quot;Get a Ticket&quot; taps</th>
            <th>Tickets held</th>
          </tr>
        </thead>
        <tbody>
          {summary.bySource.map(row => (
            <tr key={row.source ?? 'none'}>
              <td>{formatEventSource(row.source)}</td>
              <td>{row.rsvps.toLocaleString()}</td>
              <td>{row.getTicketsTaps.toLocaleString()}</td>
              <td>{row.tickets.toLocaleString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  )
}

export default EventJourneySummary
